function ContactController(){
	this.className			= "ContactController";
	this.view				= false; //"example";
	this.glob				= ["/contact**", "/contact?*"];
    this.log                = false;
}

ContactController.inheritsFrom( PageController );
ContactController.prototype.setup = function(onComplete){
	if(this.isSetup) return;
	this.$body				= $('body');
	this.isSetup = true;
};

ContactController.prototype.on = function(){
	this.signupForm = new SignupForm();
};

ContactController.prototype.off = function(){
	this.signupForm.destroy();
};

ContactController.prototype.swap = function(){
	if(!this.isSetup) this.setup();
	this.$page  = this.$body.find('.js-page');
};